import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialCommitteeMeetingState: Dtos.CommitteeMeeting & IRegistrationFormState = {
    id: null,
    committeeId: null,
    committee: null,
    meetingDate: null,
    location: null,
    website: null,
    comments: null,
    committeeMeetingTypeId: null,
    committeeMeetingType: null,
    city: null,
    time: null,
    room: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    committeeMembers: [],
    committeeRegularInvitees: [],
    saveAndReturn: false,
}

export interface ICommitteeMeetingReduxFormState {
    id: IFieldState<number>,
    committeeId: IFieldState<number>,
    meetingDate: IFieldState<string>;
    location: IFieldState<string>;
    website: IFieldState<string>;
    comments: IFieldState<string>;
    committeeMeetingTypeId: IFieldState<number>;
    city: IFieldState<string>,
    time: IFieldState<string>,
    room: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    openedModals: IFieldState<string[]>,
}
